module.exports = new __parcel__URL__("msu.3e2c8b2b.png").toString();